module.exports = __webpack_public_path__ + "img/g4_caobianweizhuangkui.b85b8a89.jpg";